import styled from "styled-components";
import IconButton from "../../../commonComponents/IconButton/IconButton";
import tactiveLogo from "./tactiveLogo.png";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CreateIcon from "@mui/icons-material/Create";
import PersonIcon from "@mui/icons-material/Person";

const BodyWrapper = styled.div`
  background-color: white;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 20px 20px;
  width: 320px;
  height: 188px;
`;

const Header = styled.div`
  display: flex;
`;

const TactiveLogo = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 25px;
`;

const CardTitle = styled.div`
  color: #004576;
  font-weight: 700;
  font-size: 16px;
  width: 200px;
`;

const CardActionButtonsContainer = styled.div`
  width: 30%;
  width: 120px;
  display: flex;
  gap: 10px;
  justify-content: end;
`;

const Body = styled.div`
  display: flex;
  margin-top: 30px;
`;
const InfoSection = styled.div`
  text-align: center;
  width: 25%;
  border-left: ${(props) => (props?.isFirst ? "none" : "1px solid #b3bac0")};
  font-weight: 700;
  font-size: 20px;
  color: ${(props) => (props.isPercentage ? "#479B05" : "#004576")};
`;

const Footer = styled.div`
  margin-top: 10px;
`;

const Information = styled.div`
  display: flex;

  .footerInfo {
    color: #9d9d9d;
    font-weight: 400;
    font-size: 12px;
    width: 50%;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 10px;
  gap: 10px;
  .modelType {
    width: 90%;
    background: #e7edf2;
    border-radius: 4px;
    padding: 8px 0px;
    text-align: center;
    color: #004576;
    font-weight: 400;
    font-size: 12px;
  }
`;

const ModelCard = ({ cardTitle, iseFeatureModelCard }) => {
  return (
    <BodyWrapper>
      <Header>
        <CardTitle>{cardTitle}</CardTitle>
        <CardActionButtonsContainer>
          {iseFeatureModelCard && (
            <IconButton
              icon={
                <IconButton
                  icon={<CreateIcon sx={{ fontSize: 20, color: "#004576" }} />}
                />
              }
            />
          )}

          <IconButton
            icon={<PersonIcon sx={{ fontSize: 20, color: "#004576" }} />}
          />
        </CardActionButtonsContainer>
      </Header>
      <TactiveLogo>
        <img
          src={tactiveLogo}
          style={{ visibility: iseFeatureModelCard ? "none" : "hidden" }}
        />
      </TactiveLogo>
      <Body>
        <InfoSection isFirst={true}>#</InfoSection>
        <InfoSection>#</InfoSection>
        <InfoSection isPercentage={true}>%</InfoSection>
        <InfoSection>#</InfoSection>
      </Body>
      <Footer>
        <Information>
          <div className="footerInfo">Last Edit: 00/00/0000</div>
          <div className="footerInfo" style={{ textAlign: "right" }}>
            Version: #
          </div>
        </Information>
        <ButtonContainer>
          <div className="modelType">Conservative</div>
          <div style={{ display: "flex", justifyContent: "right" }}>
            <IconButton
              icon={
                <AssessmentOutlinedIcon
                  sx={{ fontSize: 27, color: "#004576" }}
                />
              }
            />
          </div>
        </ButtonContainer>
      </Footer>
    </BodyWrapper>
  );
};

export default ModelCard;
